import { Directive } from '@angular/core';
@Directive({
  selector: 'xpo-header-navigation-sub-menu',
})
// Just defined to allow user to use the selector in their HTML
export class XpoHeaderSubMenuDirective {}
